import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import SolutionsPage from './pages/SolutionsPage';
import CasesPage from './pages/CasesPage';
import AboutPage from './pages/AboutPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProductDetail from './pages/ProductDetail';
import SolutionDetail from './pages/SolutionDetail';
import CaseDetail from './pages/CaseDetail';
import AboutDetail from './pages/AboutDetail';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <div className="flex flex-col min-h-screen" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/products" element={<ProductsPage data-id="element-9" />} data-id="element-8" />
            <Route path="/products/:id" element={<ProductDetail data-id="element-11" />} data-id="element-10" />
            <Route path="/solutions" element={<SolutionsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/solutions/:category/:id" element={<SolutionDetail data-id="element-15" />} data-id="element-14" />
            <Route path="/cases" element={<CasesPage data-id="element-17" />} data-id="element-16" />
            <Route path="/cases/:category/:id" element={<CaseDetail data-id="element-19" />} data-id="element-18" />
            <Route path="/about" element={<AboutPage data-id="element-21" />} data-id="element-20" />
            <Route path="/about/:section" element={<AboutDetail data-id="element-23" />} data-id="element-22" />
          </Routes>
        </main>
        <Footer data-id="element-24" />
      </div>
    </BrowserRouter>;
}